import { ERoleCode } from 'types/enumItems';
import type { TCurrentUser } from 'types/group';

// 「owner 视角」判定（Practice view / 可编辑 / dashboard 准入口径），一律走 currentUser：
// solo 全员视为 owner 视角（owner 本人与代持的 staff）；group 为 owner 本人或 admin staff。
// 不要用 /status 的 canBind 判 owner —— OPS 代登录时后端有意把 canBind 置 false
// （ops 不得代 provider 发起绑定），拿它当 owner 用会让 ops preview 下的 group owner
// 被误判成团队 provider（只剩 My billing 视图）。canBind 只保留「能否发起绑定」语义
// （landing Get started 请求与 onboarding 向导挂载守卫）。
export const isBillingOwnerOrAdmin = (currentUser?: TCurrentUser): boolean => {
    if (!currentUser) {
        return false;
    }
    if (!currentUser.groupPractice) {
        return true;
    }
    return (
        currentUser.roleCode === ERoleCode.GROUP_OWNER ||
        !!currentUser.isAdmin ||
        currentUser.roleCode === ERoleCode.GROUP_ADMINISTRATIVE_ASSISTANT ||
        currentUser.roleCode === ERoleCode.GROUP_PRACTICE_MANAGER
    );
};
